import React, { useState } from "react";
import {
  Box,
  Button,
  IconButton,
  Modal,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Paper,
} from "@mui/material";
import { Add, Edit, Delete, Close } from "@mui/icons-material";
import "./SalaryOnHand.css";

const emptyForm = {
  id: "",
  employeeName: "",
  payAction: "",
  startPeriod: "",
};

const SalaryOnHand = () => {
  const [data, setData] = useState([]);
  const [form, setForm] = useState(emptyForm);
  const [open, setOpen] = useState(false);
  const [editIndex, setEditIndex] = useState(null);

  const openModal = (row = null, index = null) => {
    setForm(row || emptyForm);
    setEditIndex(index);
    setOpen(true);
  };

  const closeModal = () => {
    setOpen(false);
    setForm(emptyForm);
    setEditIndex(null);
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSave = () => {
    if (Object.values(form).some((v) => v === "")) {
      alert("All fields are required");
      return;
    }

    if (editIndex !== null) {
      const updated = [...data];
      updated[editIndex] = form;
      setData(updated);
    } else {
      setData([...data, form]);
    }
    closeModal();
  };

  const handleDelete = (index) => {
    if (window.confirm("Delete this record?")) {
      setData(data.filter((_, i) => i !== index));
    }
  };

  return (
    <div className="onhand-wrapper">
      <div className="onhand-card">
        <div className="onhand-header">
          <h2>Salary On-Hand</h2>
          <Button
            className="onhand-add-btn"
            startIcon={<Add />}
            onClick={() => openModal()}
          >
            Add Record
          </Button>
        </div>

        <TableContainer component={Paper} className="onhand-table">
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell>S.No</TableCell>
                <TableCell>ID</TableCell>
                <TableCell>Employee Name</TableCell>
                <TableCell>Pay Action</TableCell>
                <TableCell>Start Period</TableCell>
                <TableCell align="center">Action</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {data.map((row, index) => (
                <TableRow key={index}>
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>{row.id}</TableCell>
                  <TableCell>{row.employeeName}</TableCell>
                  <TableCell>{row.payAction}</TableCell>
                  <TableCell>{row.startPeriod}</TableCell>
                  <TableCell align="center">
                    <IconButton
                      color="warning"
                      onClick={() => openModal(row, index)}
                    >
                      <Edit />
                    </IconButton>
                    <IconButton
                      color="error"
                      onClick={() => handleDelete(index)}
                    >
                      <Delete />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}

              {!data.length && (
                <TableRow>
                  <TableCell colSpan={6} align="center">
                    No salary on-hand records found
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </div>

      {/* MODAL */}
      <Modal open={open} onClose={closeModal}>
        <Box className="onhand-modal">
          <div className="modal-header">
            <h3>Salary On-Hand Entry</h3>
            <IconButton onClick={closeModal}>
              <Close />
            </IconButton>
          </div>

          <div className="modal-grid">
            <TextField
              label="Employee ID"
              name="id"
              value={form.id}
              onChange={handleChange}
              size="small"
            />
            <TextField
              label="Employee Name"
              name="employeeName"
              value={form.employeeName}
              onChange={handleChange}
              size="small"
            />
            <TextField
              label="Pay Action"
              name="payAction"
              value={form.payAction}
              onChange={handleChange}
              size="small"
            />
            <TextField
              label="Start Period"
              name="startPeriod"
              value={form.startPeriod}
              onChange={handleChange}
              size="small"
            />
          </div>

          <Button className="onhand-save-btn" onClick={handleSave}>
            Save
          </Button>
        </Box>
      </Modal>
    </div>
  );
};

export default SalaryOnHand;
